import {
  Dialog,
  DialogContent,
  CardContent,
  Button,
  DataGrid,
  Box,
} from "../../../../components";
import { NcmService } from "../../../../services";
import { responseErros } from "../../../../utils";

const ncmService = new NcmService();

export default function PainelAnaliseFiscalProdutosNcmDialog({
  open,
  setOpen,
  ncmsInconsistentes = [],
  revisarProdutoAnaliseFiscal,
}) {
  const ncmsInconsistentesColunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "descricao",
      headerName: "Produto",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "ncmCodigo",
      headerName: "NCM Atual",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "ncmSugerido",
      headerName: "NCM Sugerido",
      flex: 1,
      minWidth: 120,
    },
  ];

  const buscarNcms = async (codigo) => {
    const filtros = {
      codigo,
      nonPaginated: true,
    };
    if (codigo.length) {
      const result = await ncmService.getAllAvancado(filtros);
      if (!result.isAxiosError) {
        return result.data;
      } else responseErros(result);
    }
  };

  async function handleRevisarNcm() {
    const ncms = [
      ...new Set(ncmsInconsistentes.map((item) => item.ncmSugerido)),
    ];
    const ncmsSugeridos = await buscarNcms(ncms);
    const mergeNcms = ncmsInconsistentes
      .map((item) => {
        const ncmSugerido = ncmsSugeridos.find(
          ({ codigo: ncmCodigo }) => ncmCodigo === item.ncmSugerido,
        );
        return {
          id: item.produtoId,
          ncmId: ncmSugerido?.id || null,
          ncmCodigo: item.ncmSugerido || "",
        };
      })
      .filter((item) => item.ncmId && item.id);
    revisarProdutoAnaliseFiscal(mergeNcms, setOpen);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "0.7rem",
          background: "white",
        },
      }}
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <Box className="d-flex justify-content-between align-items-center my-2 mx-3">
          <h6 className="text-uppercase fw-bold pt-2">
            Produtos com NCM Inconsistente
          </h6>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleRevisarNcm}
          >
            Revisar
          </Button>
        </Box>
        <CardContent>
          <DataGrid
            rows={ncmsInconsistentes}
            columns={ncmsInconsistentesColunas}
            rowCount={ncmsInconsistentes.length}
            disableAcoes
          />
          <Box
            className="mt-4 p-3 d-flex justify-content-center align-items-center rounded-4"
            sx={{
              background: "#006eff27",
            }}
          >
            <i className="ph-fill ph-sparkle" /> NCMs são sugeridas por
            Inteligência Artificial e que requer validação junto ao departamento
            fiscal
          </Box>
        </CardContent>
      </DialogContent>
    </Dialog>
  );
}
